import { useDispatch, useSelector } from 'react-redux'
import { wsSlice } from '../../wsSlice'
import { logger } from 'helpers/logger'
import { useEffect, MutableRefObject } from 'react'
import ReconnectingWebSocket from 'reconnecting-websocket'
import { WsSubscribeMessage } from '../../types'
import { getTopics } from '../helpers/getTopics'

type UseUnSubscribeProps = {
  isReady: boolean
  socket: ReconnectingWebSocket | null
  serverSubscriptions: MutableRefObject<WsSubscribeMessage[]>
}
export const useUnSubscribe = ({
  isReady,
  socket,
  serverSubscriptions,
}: UseUnSubscribeProps) => {
  const dispatch = useDispatch()
  const unsubscribers = useSelector(wsSlice.selectors.selectUnSubscribers)

  useEffect(() => {
    if (isReady && socket) {
      const topics = getTopics(unsubscribers)
      if (topics.length === 0) return
      try {
        socket.send(
          JSON.stringify({
            type: 'UNSUBSCRIBE',
            topics,
          }),
        )

        serverSubscriptions.current = serverSubscriptions.current?.filter(
          (s) => !unsubscribers.find((u) => u.id === s.id),
        )

        logger.debug('WebSocket unsubscribed from: ', topics)
      } catch (e) {
        logger.error('WebSocket error when send: ', e)
      }
    }

    unsubscribers.forEach((subscriber) => {
      dispatch(wsSlice.actions.onUnsubscribe(subscriber.id))
    })
  }, [unsubscribers, socket, isReady])
}
